import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { Message } from 'lib/_types'

type Props = {
  message: Message
  isCurrentUserMessage: boolean
}

export const useMessageMediaInfo = ({
  message,
  isCurrentUserMessage,
}: Props) => {
  const { t } = useTranslation()

  return useMemo(() => {
    let text = message?.text
    let mediaPath = ''
    let thumbnailPath = ''
    let iconPath = ''
    let isOneTime = false
    let isVideo = false
    let isDeleted = false
    let shouldRender = true

    switch (message?.message_type) {
      case 'gif':
        text = t('common.message_type.gif')
        mediaPath = message.gif?.url
        thumbnailPath = message.gif?.url
        break

      case 'sticker':
        text = t('common.message_type.sticker')
        mediaPath = message.sticker?.url
        thumbnailPath = message.sticker?.url
        break

      case 'image':
      case 'eternal_image':
      case 'video':
      case 'eternal_video':
        isOneTime = !message.message_type.includes('eternal')
        isVideo = message.message_type.includes('video')
        mediaPath = (isVideo ? message.video_url : message.attachment)?.trim()
        thumbnailPath = (
          message._sending
            ? message.attachment
            : isVideo
            ? message.video_thumbnail_url
            : message.attachment_thumbnail
        )?.trim()
        isDeleted = message.text === '[removed]' || !mediaPath

        if (isDeleted) {
          text = isVideo
            ? t('chat.message.reply.video.opened')
            : t('chat.message.reply.image.opened')
          iconPath = isVideo
            ? '/images/icon-chat-reply-video.svg'
            : '/images/icon-chat-reply-image.svg'
          shouldRender = false
          break
        }

        if (!isCurrentUserMessage && isOneTime) {
          text = isVideo
            ? t('chat.message.reply.video.unopened')
            : t('chat.message.reply.image.unopened')
          iconPath = isVideo
            ? '/images/icon-chat-reply-video.svg'
            : '/images/icon-chat-reply-image.svg'
          shouldRender = false
          break
        }

        text = isVideo
          ? t('common.message_type.video')
          : t('common.message_type.image')
        break

      default:
        break
    }

    return {
      text,
      mediaPath,
      thumbnailPath,
      iconPath,
      isOneTime,
      isVideo,
      isDeleted,
      shouldRender,
    }
  }, [message, isCurrentUserMessage])
}
